// Responsive table handling for mobile
// function initResponsiveTables() {
//     if (window.innerWidth < 768) { // Mobile breakpoint
//         $('.st-table-tab__table').each(function() {
//             const $table = $(this);
//             const $headers = $table.find('thead th');
            
//             // Skip if already processed
//             if ($table.hasClass('responsive-processed')) return;
            
//             $table.find('tbody tr').each(function() {
//                 $(this).find('td').each(function(index) {
//                     const headerText = $headers.eq(index + 1).text(); // +1 because first header is empty
//                     $(this).attr('data-label', headerText);
//                 });
//             });
            
//             $table.addClass('responsive-processed');
//         });
//     }
// }


( function( $ ) {

    $(document).ready( function() {
        
        // Initialize tabs functionality
        function initContentTabs() {
            $('.st-table-tab-block').each(function() {
                const $block = $(this);
                const $tabButtons = $block.find('.st-table-tab__button');
                const $tabPanes = $block.find('.st-table-tab__pane');
                
                // Set first tab as active by default
                if (!$tabButtons.hasClass('active')) {
                    $tabButtons.first().addClass('active');
                    $tabPanes.first().addClass('active');
                }
                
                // Tab click handler
                $tabButtons.on('click', function(e) {
                    e.preventDefault();
                    
                    const $this = $(this);
                    const tabId = $this.data('tab');
                    
                    // Remove active classes
                    $tabButtons.removeClass('active');
                    $tabPanes.removeClass('active');
                    
                    // Add active classes to clicked tab
                    $this.addClass('active');
                    $block.find('#' + tabId).addClass('active');
                });
            });
        }
        
        // Initialize on page load
        initContentTabs();
        
        // Re-initialize when block is added in editor
        if (typeof wp !== 'undefined' && wp.data && wp.data.subscribe) {
            wp.data.subscribe(function() {
                setTimeout(initContentTabs, 100);
            });
        }

         initContentTabs();
   // initResponsiveTables();
    
    // Re-init responsive tables on window resize
    // $(window).on('resize', function() {
    //     initResponsiveTables();
    // });
    } );

} )( jQuery );